export default "__VITE_ASSET__CEgjRPhA__"